import { frontendURL } from '../../../helper/URLHelper';
import {
  ROLES,
  CONVERSATION_PERMISSIONS,
} from '../../../constants/permissions';
import LeadsIndex from './pages/LeadsIndex.vue';
import LeadDetail from './pages/LeadDetail.vue';

// Mismo modelo de permisos que Conversaciones (roles + permisos de conversación):
// un agente con rol custom lleva permissions=[...sus permisos de conversación,
// 'custom_role'] y NUNCA 'agent', así que ['administrator','agent'] lo dejaba sin
// ver el módulo. Las policies LeadPolicy/LeadTaskPolicy limitan QUÉ ve cada uno.
const meta = {
  permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/leads'),
    name: 'leads_dashboard_index',
    component: LeadsIndex,
    meta,
  },
  {
    // Antes de :leadId para que "/leads/new" no se interprete como un id.
    path: frontendURL('accounts/:accountId/leads/new'),
    name: 'leads_new',
    component: LeadDetail,
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/leads/:leadId'),
    name: 'leads_show',
    component: LeadDetail,
    meta,
  },
];
